import React from 'react';
import Hero from '../components/Hero';
import SeasonBanner from '../components/SeasonBanner';
import Renovation from '../components/Renovation';
import Services from '../components/Services';
import ServicesLinks from '../components/ServicesLinks';
import Coproprietes from '../components/Coproprietes';
import PartnersTeaser from '../components/PartnersTeaser';
import WhyChoose from '../components/WhyChoose';
import VideoSection from '../components/VideoSection';
import GoogleReviews from '../components/GoogleReviews';
import EcoPositioning from '../components/EcoPositioning';
import Process from '../components/Process';
import Zone from '../components/Zone';
import About from '../components/About';
import Contact from '../components/Contact';
import Credentials from '../components/Credentials';
import { Seo } from '../components/Seo';
import { SITE } from '../data/siteConfig';

const homeJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: SITE.legalName,
    url: SITE.url,
    logo: SITE.logo,
    telephone: SITE.phone,
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: SITE.phone,
      email: SITE.email,
      contactType: 'customer service',
      areaServed: 'FR',
      availableLanguage: 'French',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'GeneralContractor',
    '@id': `${SITE.url}/#business`,
    name: SITE.legalName,
    image: SITE.logo,
    url: SITE.url,
    telephone: SITE.phone,
    address: {
      '@type': 'PostalAddress',
      streetAddress: SITE.street,
      postalCode: SITE.postalCode,
      addressLocality: SITE.city,
      addressRegion: SITE.region,
      addressCountry: 'FR',
    },
    areaServed: SITE.areaServed.map((a) => ({ '@type': 'City', name: a })),
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: SITE.legalName,
    url: SITE.url,
  },
];

const Home = () => {
  return (
    <>
      <Seo
        title="VIREO | Entreprise de Rénovation à Paris & Île-de-France"
        description="VIREO, entreprise générale de rénovation à Paris et en Île-de-France : ravalement de façade, isolation thermique extérieure (ITE), rénovation tous corps d’état, étanchéité et couverture. Devis gratuit."
        path="/"
        jsonLd={homeJsonLd}
      />
      <Hero />
      <SeasonBanner />
      <Renovation />
      <Services />
      <ServicesLinks />
      <Coproprietes />
      <PartnersTeaser />
      <WhyChoose />
      <VideoSection />
      <GoogleReviews />
      <EcoPositioning />
      <Process />
      <Zone />
      <About />
      <Credentials />
      <Contact />
    </>
  );
};

export default Home;
